// Debug panel (Phase 5 leaf module) — renders the Logger ring buffer. Depends only on Logger.
// MUST keep window.DebugPanel: index.html wires its buttons via inline onclick="DebugPanel.*".
// NOTE: emits Tailwind classes — tailwind.config content must scan src/**/*.js.
import { Logger } from './logger.js';

export const DebugPanel = {
    open: false,
    levelFilter: 'all',
    timer: null,
    LEVEL_CLS: { error: 'text-rose-300', warn: 'text-amber-300', info: 'text-sky-300', debug: 'text-slate-400' },
    toggle() { this.open ? this.close() : this.show(); },
    show() {
        const el = document.getElementById('debugPanel');
        if (!el) return;
        this.open = true;
        el.classList.remove('hidden');
        this.render();
        this.timer = setInterval(() => this.render(), 1000); // live refresh while open
    },
    close() {
        const el = document.getElementById('debugPanel');
        if (el) el.classList.add('hidden');
        this.open = false;
        if (this.timer) { clearInterval(this.timer); this.timer = null; }
    },
    setLevel(lvl) {
        // Drive the Logger's console threshold AND the panel's display filter.
        if (lvl === 'all') { this.levelFilter = 'all'; }
        else { this.levelFilter = lvl; }
        if (Logger.LEVELS[lvl]) Logger.level = lvl;
        document.querySelectorAll('#debugLevelBtns [data-dlevel]').forEach(b => {
            const on = b.dataset.dlevel === lvl;
            b.className = 'px-2 py-0.5 rounded text-[10px] font-bold ' +
                (on ? 'bg-blue-600 text-white' : 'bg-slate-800 text-slate-400 hover:text-white');
        });
        this.render();
    },
    clear() { Logger.buffer.length = 0; this.render(); },
    render() {
        const body = document.getElementById('debugPanelBody');
        if (!body) return;
        const rank = Logger.LEVELS;
        let events = Logger.recent(200);
        if (this.levelFilter !== 'all') {
            const max = rank[this.levelFilter] || 4;
            events = events.filter(e => (rank[e.level] || 4) <= max);
        }
        if (!events.length) {
            body.innerHTML = '<div class="text-slate-600 italic text-[11px] py-3 px-2">No events logged yet. Run a scan or load a ticker.</div>';
            return;
        }
        const fmtTime = (t) => new Date(t).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', second: '2-digit' });
        const esc = (s) => String(s).replace(/[&<>]/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;' }[c]));
        body.innerHTML = events.slice().reverse().map(e => {
            const cls = this.LEVEL_CLS[e.level] || 'text-slate-300';
            const ctx = (e.context && Object.keys(e.context).length)
                ? `<span class="text-slate-500"> · ${esc(JSON.stringify(e.context))}</span>` : '';
            return `<div class="py-1 px-2 border-b border-slate-800/60 text-[11px] leading-snug">
                <span class="text-slate-600 tabular-nums">${fmtTime(e.t)}</span>
                <span class="${cls} font-bold uppercase ml-1.5">${e.level}</span>
                <span class="text-slate-300 ml-1.5">${esc(e.msg)}</span>${ctx}
            </div>`;
        }).join('');
    }
};
if (typeof window !== 'undefined') window.DebugPanel = DebugPanel;
